import { Tooltip } from "@mui/material";
import { FC } from "react";
import { ShopButtonWrapperStyles } from "../../../pages/groups/GroupsBlock/GroupsBlock.styles";
import { GeneralButton } from "../../../common/ui/GeneralButton";
import { AddCard, CreditCard, MonetizationOn, Savings, ShoppingBasket, ShoppingCart } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { ShopModuleType } from "../../../types/shopModuleTypes";

interface ShopButtonProps {
  type: ShopModuleType;
  showTooltip?: boolean;
  onClick?: () => void;
}

const ShopButton: FC<ShopButtonProps> = ({
  type,
  showTooltip = true,
  onClick
}) => {
  const { t } = useTranslation();

  const iconButton = (
    <GeneralButton appVariant="icon" onClick={onClick}>
      {GetIconByType(type)}
    </GeneralButton>
  );

  return (
    <ShopButtonWrapperStyles>
      {showTooltip 
        ? (<Tooltip title={t(`groupsPage.shopModules.${type}`, type)}>{iconButton}</Tooltip>) 
        : iconButton
      }
    </ShopButtonWrapperStyles>
  );
};

const GetIconByType = (type: ShopModuleType) => {
  switch (type) {
    case 'CompanyPension':
      return <Savings/>;
    case 'DirectPayout':
      return <MonetizationOn/>;
    case 'TaxFreeBenefitBonus':
      return <AddCard/>;
    case 'TaxFreeBenefit':
      return <CreditCard/>;
    case 'VoucherShop':
      return <ShoppingBasket/>;
    default:
      return <ShoppingCart/>;
  }
}

export default ShopButton;
